export default "__VITE_ASSET__kp8$bDLL__"